import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useAlfredChatContext } from "@/providers/alfred/chat";
import { Button } from "@/ui/button";

const ROUTE_SUGGESTIONS: Record<string, string[]> = {
    "/accounts": [
        "Show accounts summary",
        "What is my total balance?",
        "List all asset accounts",
    ],
    "/data-sources": [
        "Check data source health",
        "Show sync status",
        "What is the source health?",
    ],
    "/ledger": [
        "Show recent transactions",
        "Search for transactions",
        "Count transactions this month",
    ],
    "/reconciliations": [
        "Show reconciliation status",
        "What are the top 10 exceptions?",
        "List unmatched transactions",
    ],
};

const DEFAULT_SUGGESTIONS = [
    "Show accounts summary",
    "Show recent transactions",
    "Check data source health",
];

export const AlfredSuggestionChips = () => {
    const { pathname } = useLocation();
    const {
        isLoading,
        messages,
        sendMessage,
        setIsOpen,
    } = useAlfredChatContext();

    const suggestions = useMemo(
        () => {
            // Hide suggestions once conversation has started
            if (messages.length > 0) return [];

            // Find suggestions matching current route
            for (const [route, chips] of Object.entries(ROUTE_SUGGESTIONS)) if (pathname.includes(route)) return chips; // eslint-disable-line

            return DEFAULT_SUGGESTIONS;
        },
        [pathname, messages.length],
    );

    const handleChipClick = useCallback(
        (suggestion: string) => {
            setIsOpen(true);
            sendMessage(suggestion);
        },
        [sendMessage, setIsOpen],
    );

    if (suggestions.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-2">
            {suggestions.map((suggestion) => (
                <Button
                    className="h-auto whitespace-normal px-3 py-2 text-left text-xs"
                    disabled={isLoading}
                    key={suggestion}
                    variant="outline"
                    onClick={() => handleChipClick(suggestion)}
                >
                    {suggestion}
                </Button>
            ))}
        </div>
    );
};
